export const LAYOUT_SECTION_MARGIN = 8;
export const LAYOUT_COLUMN_PADDING = LAYOUT_SECTION_MARGIN * 1.5;
